export default "__VITE_ASSET__bc59b165__"